import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessAttachmentsRoute: InvariantJiraRoute = {
	name: 'classic-business-attachments',
	path: '/jira/core/projects/:projectKey/attachments',
};
